import { batchValueRegex } from '@/constants';
import { Flex, Heading, InputRightElement } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ERRORS } from '../../constants';
import type { IAuctionHouseInfo } from '../../types';
import { AddressFields, MbeInput } from '../shared';

export const AuctionHouseInfo: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  const {
    formState: { errors },
    register,
  } = useFormContext<IAuctionHouseInfo>();

  return (
    <>
      <Flex flexDir="column">
        <Heading fontSize="large" fontWeight="bold" mb={4}>
          {t('WIZARD.AUCTION_HOUSE.FORM_HEADER_ONE')}
        </Heading>
        <Flex flexDir="column" gap={12}>
          <MbeInput
            error={errors.name}
            id="name"
            placeholder={t('FORM.AUCTION_NAME')}
            {...register('name', { required: { value: true, message: t(ERRORS.empty) } })}
          />
          <AddressFields />
        </Flex>
      </Flex>
      <Flex flexDir="column">
        <Heading fontSize="large" fontWeight="bold" mb={4}>
          {t('WIZARD.AUCTION_HOUSE.FORM_HEADER_TWO')}
        </Heading>
        <Flex flexDir="column" gap={12}>
          <MbeInput
            error={errors.auctionCode}
            id="auctionCode"
            placeholder={t('FORM.AUCTION_NAME_OR_CODE')}
            {...register('auctionCode')}
          />
          <MbeInput
            error={errors.auctionDate}
            id="auctionDate"
            placeholder={t('FORM.AUCTION_DATE')}
            type="date"
            {...register('auctionDate')}
          />
          <MbeInput
            error={errors.batchCode}
            id="batchCode"
            placeholder={t('FORM.BATCH_CODE')}
            {...register('batchCode')}
          />
          <MbeInput
            error={errors.batchValue}
            id="batchValue"
            placeholder={t('FORM.BATCH_VALUE')}
            {...register('batchValue', {
              required: { value: true, message: t(ERRORS.empty) },
              pattern: { value: batchValueRegex, message: t(ERRORS.invalidBatchValue) },
            })}
            rightElement={<InputRightElement>€</InputRightElement>}
          />
        </Flex>
      </Flex>
    </>
  );
};
